import { render, staticRenderFns } from "./RegisteredEvents.vue?vue&type=template&id=50f3d652&"
import script from "./RegisteredEvents.vue?vue&type=script&lang=js&"
export * from "./RegisteredEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports